export default __webpack_public_path__ + "static/space-bg-2fe399da5972e149c5ddbaa1023cb4dc.jpg";